import type { Langs } from '@CS/components/TranslationProvider/types';

import type { CSSProperties } from 'react';
import { useTranslation } from '@CS/hooks';

export type LocalizedImageProps = {
  crossOrigin?: 'anonymous' | 'use-credentials';
  images: Record<Langs, string>;
  customStyle?: CSSProperties;
  loading?: 'eager' | 'lazy';

  referrerPolicy?:
    | 'no-referrer-when-downgrade'
    | 'origin-when-cross-origin'
    | 'no-referrer'
    | 'unsafe-url'
    | 'origin';

  height?: number;
  width?: number;
  name?: string;
};

export const LocalizedImage = ({
  referrerPolicy,
  crossOrigin,
  customStyle,
  loading,
  images,
  height,
  width,
  name
}: LocalizedImageProps) => (
  <img
    referrerPolicy={referrerPolicy}
    src={useTranslation(images)}
    crossOrigin={crossOrigin}
    style={customStyle}
    loading={loading}
    height={height}
    width={width}
    alt={name}
  />
);
